<template>
  <section class="map-section">
    <div class="row map-wrapper">
      <div class="col-12 col-xl-5 map-nav-wrapper">
        <div class="wow fadeInLeft" data-wow-duration="2s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b9subtitle')" class="section-title">{{subtitle}}</span>
          <h3 v-bind="$parent.dKey('b9title')">{{title}}</h3>
          <div class="nav-form">
            <form action="#" @submit="formSubmit">
              <div class="select-wrapper">
                <span v-if="$root.isAdmin()" v-bind="$parent.dKey('b9country')">{{country}}</span>
                <select v-model="mapCountry" @change="selectCountry" name="choose-country">
                  <option value="">{{country}}</option>
                  <option v-for="country in mapCountries" v-bind:value="country">{{country}}</option>
                </select>
              </div>
              <div class="select-wrapper">
                <span v-if="$root.isAdmin()" v-bind="$parent.dKey('b9city')">{{city}}</span>
                <select v-model="mapCity" name="choose-city">
                  <option value="">{{city}}</option>
                  <option v-for="city in mapCities" v-bind:value="city.city" v-bind:class="{'hidden': mapCountry != city.country}">{{city.city}}</option>
                </select>
              </div>
              <div class="show-map-btn">
                <button type="submit" v-bind="$parent.dKey('b9submit')">{{submit}}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-7 map-block">
        <div id="map"></div>
        <div v-bind="$parent.dKey('b9titleDown')" class="big-map-title resp-number">{{bgTitle}}</div>
      </div>
    </div>
  </section>
</template>

<script>

var mapStyles = [{
  "featureType": "all",
  "elementType": "geometry.fill",
  "stylers": [{
    "weight": "2.00"
  }]
}, {
  "featureType": "all",
  "elementType": "geometry.stroke",
  "stylers": [{
    "color": "#9c9c9c"
  }]
}, {
  "featureType": "all",
  "elementType": "labels.text",
  "stylers": [{
    "visibility": "on"
  }]
}, {
  "featureType": "landscape",
  "elementType": "all",
  "stylers": [{
    "color": "#f2f2f2"
  }]
}, {
  "featureType": "landscape",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "landscape.man_made",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "poi",
  "elementType": "all",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi.business",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "road",
  "elementType": "all",
  "stylers": [{
    "saturation": -100
  }, {
    "lightness": 45
  }]
}, {
  "featureType": "road",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#eeeeee"
  }]
}, {
  "featureType": "road",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#7b7b7b"
  }]
}, {
  "featureType": "road",
  "elementType": "labels.text.stroke",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "all",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "road.arterial",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit",
  "elementType": "all",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "water",
  "elementType": "all",
  "stylers": [{
    "color": "#46bcec"
  }, {
    "visibility": "on"
  }]
}, {
  "featureType": "water",
  "elementType": "geometry.fill",
  "stylers": [{
    "color": "#c8d7d4"
  }]
}, {
  "featureType": "water",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#070707"
  }]
}, {
  "featureType": "water",
  "elementType": "labels.text.stroke",
  "stylers": [{
    "color": "#ffffff"
  }]
}];

export default {
  name: 'Map',

  props: ['title', 'subtitle', 'bgTitle', 'submit', 'country', 'city'],

  data() {
    return {
      mapCountry: '',
      mapCity: '',
      mapCountries: [],
      mapCities: [],
      markers: {
        'Krakow': [50.050992, 19.978741, 12],
        'Brno': [49.202177, 16.656423, 12],
        'Wiesbaden': [50.061997, 8.241606, 12],
        'Tilburg': [51.566885, 5.083482, 12]
      }
    }
  },

  created() {
    this.$root.$on('map_data', mapdata => {
      let cities = {},
          countries = {},
          markers = {}

      mapdata.split(/\n\r?/).forEach(location => {
        let parts = location.split('|'),
            city = parts[0].trim(),
            country = parts[1].trim(),
            coords = parts[2].split(',')

        countries[country] = country

        cities[city] = {
          'city': city,
          'country': country
        }

        markers[city] = [
          parseFloat(coords[0].trim()),
          parseFloat(coords[1].trim()),
          12
        ]
      })

      this.mapCountries = countries
      this.mapCities = cities
      this.markers = markers

      if (!document.documentElement.dataset.hasOwnProperty('map'))
        this.$root.scriptLoader('https://maps.googleapis.com/maps/api/js?key=AIzaSyCWWL5MNY3ct8daaBxk0MXeY4sTh8IU5aw&callback=init', () => {
          document.documentElement.dataset.map = true
          this.resetMap()
        })
      else
        this.resetMap()
    })
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  methods: {
    getData(key, field) {
      if (this.$root.hfInfo[key] && this.$root.hfInfo[key][field]) {
        this.mapData = this.$root.hfInfo[key][field]

        return this.$root.hfInfo[key][field]
      }

      return ''
    },

    resetMap() {
      if (document.getElementById('map')) {
        let map = new google.maps.Map(document.getElementById('map'), {
            zoom: 4,
            center: new google.maps.LatLng(50.6700, 15.9400), // New York
            styles: mapStyles,
        });

        for(let i in this.markers) {
          this.setMarkers(map, this.markers[i])
        }
      }
    },

    formSubmit(event) {
      event.preventDefault()

      if (this.mapCity) {
        let map = new google.maps.Map(document.getElementById('map'), {
            zoom: 15,
            center: new google.maps.LatLng(this.markers[this.mapCity][0], this.markers[this.mapCity][1]), // New York
            styles: mapStyles
        });

        this.setMarkers(map, this.markers[this.mapCity])
      } else {
        this.resetMap()
      }
    },

    selectCountry(event) {
      this.mapCity = ''
      this.resetMap()
    },

    setMarkers(map, coords){
      let marker = new google.maps.Marker({
        position: {
          lat: coords[0],
          lng: coords[1]
        },
        map: map,
        icon: {
          url: '/static-assets/img/pin.png',
          size: new google.maps.Size(55, 71),
          origin: new google.maps.Point(0, 0)
          // anchor: new google.maps.Point(0, 71)
        },
        // shape: {
        //   coords: [1, 1, 1, 20, 18, 20, 18, 1],
        //   type: 'poly'
        // },
        title: this.mapCity,
        zIndex: coords[2]
      });
    }
  }
}

</script>
